<template>
    <!--
    <div>
        <ul>
            <li v-for="message in messages" :key="message.id">
                {{ message.id }} - {{ message.message }}
            </li>
        </ul>
        <div>
            <button @click="index">Index</button>
        </div>
        <div>
            <input type="text" v-model="newcomment">
            <button @click="store">Post</button>
        </div>

        <div>
            <input type="number" v-model="id">
            <input type="text" v-model="updatecomment">
            <button v-on:click="update(id)">Update</button>
        </div>

         <div>
            <input type="number" v-model="id">
            <button v-on:click="destroy(id)">Delete</button>
        </div>

    </div>
    -->
    <div>
        <p> Test message </p>
        <b-button v-on:click="addData">Add data</b-button>
        <div>
            <form method="POST" :action="route">
                <input type="hidden" name="_token" :value="token">
                <!--<input type="hidden" name="dataToBeSent" v-model="testData" :value="'{{testData}}'">-->
                <input type="hidden" name="dataToBeSent" v-model="testData">
                <button type="submit" >Submit</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["token", "route"],

        data() {
            return {
                count: 0,
                testData: [],
            };
        },

        mounted() {

        },

        methods: {
            addData() {
                this.testData.push(this.count);
                this.count += 1;
                console.log(this.testData);
            },
            /*
           async index() {
                const { data } = await window.axios.get('/api/test');
                this.messages = data;
            },
            async store() {
                await window.axios.post('/api/test', {message: this.newcomment});
                this.newcomment = '';
                this.index();
            },
            async show(id) {
                this.mute = true;
                await window.axios.get('/api/test/'+id);
            },
            async update(id) {
                await window.axios.put('/api/test/'+id, {message: this.updatecomment});
                this.updatecomment = '';
                this.index();
            },
            async destroy(id) {
                await window.axios.delete('/api/test/'+id);
                this.index();
            },
            */
        }
    }
</script>
